import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const PersonsSlice = createSlice({
  name: "Persons",
  initialState,
  reducers: {
    recievePersons(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(p => [p.id, p]));
    },
  },
});

export const {
  recievePersons
} = PersonsSlice.actions

export default PersonsSlice.reducer;
